import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { Button } from "@Components/CustomButton/Button"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { CustomPicker } from "@Components/FollowUp/Toolbox/CustomPicker"
import { InputGroup } from "@Components/Input/InputGroups"
import { Spacer } from "@Components/Space"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { baseColors } from "@Constants/baseStyles"
import { message } from "@Constants/constant"
import { defaultActivity } from "@Screens/Diagnostic/Logic"
import { ActivityService } from "@Services/Activity.Service"
import { dbDateFormat, getSportIcon, isNumber, isValidTime, localDateFormat } from "@Utils/utils"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { TouchableOpacity, View } from "react-native"

export const ActivityFollowUP = ({ navigation, route }) => {
    const [fetchingActivity, setFetchingActivity] = useState(false)
    const [fetchingSports, setFetchingSport] = useState(false)
    const [activity, setActivity] = useState(
        route?.params?.activity
            ? () => {
                  const activityData = route.params.activity

                  return {
                      id: activityData.id,
                      activityTypeId: activityData?.activityType?.id,
                      sportId: activityData?.sport?.id,
                      duration: activityData.duration,
                      start: activityData?.start,
                      date: moment(activityData?.date, dbDateFormat).format(localDateFormat),
                      distance: activityData?.distance ? activityData.distance : null,
                      cardiacFrequency: activityData?.cardiacFrequency ? activityData.cardiacFrequency : null,
                      pain: activityData?.pain ? activityData.pain : null,
                      glycemy: activityData?.glycemy ? activityData.glycemy : null
                  }
              }
            : defaultActivity
    )
    const [activities, setActivities] = useState([])
    const [sports, setSports] = useState([])
    const [loading, setLoading] = useState(false)

    const fetchSport = () => {
        setFetchingSport(true)
        ActivityService.getSports()
            .then((response) => {
                const data = response.data?.data
                if (data) {
                    const parsedData = data.map((item) => {
                        let newObj = {
                            id: item.id,
                            label: item.name
                        }
                        return newObj
                    })
                    setSports(parsedData)
                }
                setFetchingSport(false)
            })
            .catch((e) => {
                setFetchingSport(false)
                ShowToast({ type: "error", message: message.serverError })
            })
    }

    const fetchActivityTypes = () => {
        setFetchingActivity(true)
        ActivityService.getType()
            .then((response) => {
                const data = response.data?.data
                if (data) {
                    const parsedData = data.map((item) => {
                        let newObj = {
                            id: item.id,
                            code: item.code,
                            label: item.name
                        }
                        return newObj
                    })
                    setActivities(parsedData)
                }
                setFetchingActivity(false)
            })
            .catch((e) => {
                ShowToast({ type: "error", message: message.serverError })
                setFetchingActivity(false)
            })
    }

    useEffect(() => {
        fetchActivityTypes()
        fetchSport()
    }, [])
    const canSubmit = () =>
        activity.activityTypeId && activity.sportId && isNumber(activity.duration) && isValidTime(activity.start)

    const performSaveActivity = () => {
        if (activity.id) {
            setLoading(true)
            let data = activity
            data.date = moment(activity.date, localDateFormat).format(dbDateFormat)
            ActivityService.update(activity?.id, data)
                .then((response) => {
                    setLoading(false)
                    ShowToast({ type: "success", message: message.updatedSuccess })
                    //setActivity(defaultActivity)
                    navigation.goBack()
                })
                .catch((e) => {
                    setLoading(false)
                    ShowToast({ type: "error", message: message.serverError })
                })
        } else {
            alert("No activity id")
        }
    }

    const renderItem = ({ item }, { onPress }) => {
        return (
            <TouchableOpacity
                onPress={() => {
                    setActivity((old) => ({ ...old, sportId: item.id }))
                }}
                activeOpacity={0.7}
                style={{ flexDirection: "row", padding: 10 }}
            >
                <View style={{ marginRight: 20 }}>{item.icon}</View>
                <OpenSansText fontSize={16}>{item.name}</OpenSansText>
            </TouchableOpacity>
        )
    }

    return (
        <ContainerStackScreen>
            <CustomScrollview contentContainerStyle={{ paddingBottom: 100 }} showsVerticalScrollIndicator={false}>
                <BreeSerifText color={baseColors.black} fontSize={24}>
                    Suivi de l'activité
                </BreeSerifText>
                <Spacer height={15} />
                <OpenSansText fontSize={16}>Choisissez un type d’activité physique</OpenSansText>
                <CustomPicker
                    value={activity.activityTypeId}
                    handleChange={(value) => setActivity((old) => ({ ...old, activityTypeId: value }))}
                    disabled={fetchingActivity || loading}
                    data={activities}
                    title={"Sélectionnez un type d’activité"}
                />
                <Spacer height={15} />
                {sports?.length > 0 && (
                    <InputGroup
                        label={"Exercice"}
                        disabled={true}
                        validation_message={""}
                        placeholder={"Exemple"}
                        value={sports.filter((sp) => sp.id === activity.sportId)[0].label}
                        //onChange={(txt) => setActivity((old) => ({ ...old, sportId: txt }))}
                    />
                )}
                {activity.duration && (
                    <InputGroup
                        disabled={true}
                        code
                        valid={isNumber(activity.duration)}
                        validation_message={"Minutes (ex: 20)"}
                        label={"Durée"}
                        placeholder={"Exemple : 45"}
                        value={activity.duration.toString()}
                        onChange={(txt) => setActivity((old) => ({ ...old, duration: txt }))}
                    />
                )}

                <Spacer height={15} />
                <InputGroup
                    disabled={true}
                    valid={isValidTime(activity.start)}
                    validation_message={"Heure invalide 'ex : 16:00)"}
                    label={"Début de l'activité"}
                    placeholder={"Entrez une horaire exemple 16 : 00"}
                    value={activity.start}
                    onChange={(txt) => setActivity((old) => ({ ...old, start: txt }))}
                />
                <InputGroup
                    disabled={true}
                    label={"Date de l'activité"}
                    placeholder={"Date"}
                    value={activity.date}
                    onChange={(txt) => setActivity((old) => ({ ...old, start: txt }))}
                />
                <InputGroup
                    code
                    disabled={loading}
                    label={"Distance (KM)"}
                    valid={isNumber(activity.distance)}
                    validation_message={"Valeur numérique requise"}
                    placeholder={"Exemple : 10"}
                    value={activity.distance?.toString()}
                    onChange={(txt) => setActivity((old) => ({ ...old, distance: txt }))}
                />
                <InputGroup
                    code
                    disabled={loading}
                    label={"Fréquence cardiaque"}
                    valid={isNumber(activity.cardiacFrequency)}
                    validation_message={"Valeur numérique requise"}
                    placeholder={"Exemple : ???"}
                    value={activity.cardiacFrequency?.toString()}
                    onChange={(txt) => setActivity((old) => ({ ...old, cardiacFrequency: txt }))}
                />

                <InputGroup
                    code
                    disabled={loading}
                    label={"Douleur"}
                    valid={isNumber(activity.pain)}
                    validation_message={"Valeur numérique requise"}
                    placeholder={"Exemple : ???"}
                    value={activity.pain?.toString()}
                    onChange={(txt) => setActivity((old) => ({ ...old, pain: txt }))}
                />

                <InputGroup
                    code
                    disabled={loading}
                    label={"Glycémie"}
                    valid={isNumber(activity.glycemy)}
                    validation_message={"Valeur numérique requise"}
                    placeholder={"Exemple : ???"}
                    value={activity.glycemy?.toString()}
                    onChange={(txt) => setActivity((old) => ({ ...old, glycemy: txt }))}
                />

                <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                    <Button
                        onPress={() => navigation.goBack()}
                        text="Annuler"
                        disabled={loading}
                        width="48%"
                        backgroundColor={baseColors.green.light}
                        labelColor={baseColors.green.primary}
                    />
                    <Button
                        onPress={() => {
                            performSaveActivity()
                        }}
                        disabled={!canSubmit() || loading}
                        text="Enregistrer"
                        width="48%"
                        loading={loading}
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                </View>
            </CustomScrollview>
        </ContainerStackScreen>
    )
}
